<template>
  <header class="main-header header-five">
    <div class="header-upper">
      <div class="container-fluid bg1">
        <ul class="lang_h">
          <li class="google-translate">
            <LanguageSwitcher />
          </li>
        </ul>
        <div class="header-inner d-flex align-items-center">
          <div class="logo-outer">
            <div class="logo">
              <router-link to="/">
                <img
                  src="/assets/images/logos/opalina_logo.png"
                  alt="Logo"
                  title="Logo"
                />
              </router-link>
            </div>
          </div>
          <div class="nav-outer clearfix d-flex align-items-center">
            <nav class="main-menu navbar-expand-lg head_title">
              <div class="navbar-header">
                <div class="mobile-logo py-15">
                  <router-link to="/">
                    <img
                      src="/assets/images/logos/opalina_logo.png"
                      alt="Logo"
                      title="Logo"
                    />
                  </router-link>
                </div>
                <button
                  type="button"
                  class="navbar-toggle mobile-hamburger"
                  data-bs-toggle="collapse"
                  data-bs-target=".custom-collapse"
                  aria-expanded="false"
                  aria-controls="custom-collapse"
                >
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </button>
              </div>
              
              <!-- Desktop Menu -->
              <div class="accord-desktop" :class="{ 'spanish-responsive': $i18n.locale === 'es' }">
                <HeaderDesktopNew />
              </div>

              <!-- Mobile Menu -->
              <div :class="{ 'spanish-responsive-mobile': $i18n.locale === 'es' }">
                <HeaderMobileNew />
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import LanguageSwitcher from "../LanguageSwitcher.vue";
import HeaderDesktopNew from "./HeaderDesktop.vue";
import HeaderMobileNew from "./HeaderMobile.vue";
import { onMounted, watch } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "Header",
  components: {
    LanguageSwitcher,
    HeaderDesktopNew,
    HeaderMobileNew,
  },
  setup() {
    const route = useRoute();

    // Store SEO composables and schemas globally
    let seoData = null;

    const initializeSEO = async () => {
      try {
        const { useSEO } = await import("../../composables/useSEO.js");
        const { useStructuredData } = await import(
          "../../composables/useStructuredData.js"
        );

        const { setPageSEO } = useSEO();
        const structuredDataComposables = useStructuredData();

        // Store all the data we need
        seoData = {
          setPageSEO,
          organizationSchema: structuredDataComposables.organizationSchema,
          websiteSchema: structuredDataComposables.websiteSchema,
          serviceSchemas: structuredDataComposables.serviceSchemas,
          injectMultipleSchemas:
            structuredDataComposables.injectMultipleSchemas,
        };

        // Inject base schemas
        const baseSchemas = [seoData.organizationSchema, seoData.websiteSchema];

        // Add service-specific schema based on current route
        const routeToServiceMap = {
          "/enterprise-banking-services": seoData.serviceSchemas.fintech,
          "/service-digital": seoData.serviceSchemas.digital,
          "/ai-automations": seoData.serviceSchemas.ai,
          "/service-cloud": seoData.serviceSchemas.cloud,
          "/service-it-staff": seoData.serviceSchemas.staffing,
        };

        const serviceSchema = routeToServiceMap[route.path];
        if (serviceSchema) {
          baseSchemas.push(serviceSchema);
        }

        seoData.injectMultipleSchemas(baseSchemas);
      } catch (error) {
        console.warn("SEO composables not available:", error);
      }
    };

    // Initialize SEO on mount
    onMounted(() => {
      initializeSEO();
    });

    // Watch for route changes to update schemas
    watch(
      () => route.path,
      (newPath) => {
        if (seoData) {
          const baseSchemas = [
            seoData.organizationSchema,
            seoData.websiteSchema,
          ];

          const routeToServiceMap = {
            "/enterprise-banking-services": seoData.serviceSchemas.fintech,
            "/service-digital": seoData.serviceSchemas.digital,
            "/ai-automations": seoData.serviceSchemas.ai,
            "/service-cloud": seoData.serviceSchemas.cloud,
            "/service-it-staff": seoData.serviceSchemas.staffing,
          };

          const serviceSchema = routeToServiceMap[newPath];
          if (serviceSchema) {
            baseSchemas.push(serviceSchema);
          }

          seoData.injectMultipleSchemas(baseSchemas);
        }
      }
    );

    return {};
  },
};
</script>



